import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const emailDuplicationAPI = createAsyncThunk('master-user/check-email', async (requestHeaders, { rejectWithValue }) => {
  try {
    const response = await fetch(
      `${ROOT_URL}/master-user/check-email`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestHeaders),
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const emailDuplication = createSlice(
  {
    name: 'emailDuplication',
    initialState,
    reducers: {},
    extraReducers: {
      [emailDuplicationAPI.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [emailDuplicationAPI.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [emailDuplicationAPI.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default emailDuplication;
